import { eyeIcon as EyeIcon, hideIcon as HideIcon } from "../../assets/Icons/icons";

const PasswordVisibilityToggle = ({ isVisible, onToggle, className = "" }) => {
  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (onToggle) onToggle(e);
  };

  const Icon = isVisible ? HideIcon : EyeIcon;

  return (
    <button
      type="button"
      onClick={handleClick}
      className={`p-1.5 rounded-md transition-colors ${className}`}
      aria-label={isVisible ? "Hide password" : "Show password"}
    >
      <Icon className="w-5 h-5" />
    </button>
  );
};

export default PasswordVisibilityToggle;
